













import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import CaosConfigurationMainTable from "./CaosConfigurationMainTable.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { FetchInstallationCaosConfigurationResData } from "@/model/communication/caosConfiguration/FetchInstallationCaosConfigurationResData";
import {
    FetchInstallationCaosConfigurationCommand,
    GetFetchInstallationsCaosConfigurationReqData,
} from "@/model/communication/caosConfiguration/FetchInstallationCaosConfigurationCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        StandardPage,
        CaosConfigurationMainTable,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            CaosConfigurationMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                let response: FetchInstallationCaosConfigurationResData = await new FetchInstallationCaosConfigurationCommand(
                    GetFetchInstallationsCaosConfigurationReqData(request)
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationUpdatesStatus request ", e);
            }
            this.loading = false;
        },
    },
});
